var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"label-type"}},[_c('div',{ref:"echarts",staticClass:"chart-box",class:_vm.labelName.length > 11 ? 'hg1' : 'hg4'})])}
var staticRenderFns = []

export { render, staticRenderFns }